// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getQueryStrings } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import getAllowancesProperties from "@store/Framework/Store/Store/Data/Allowance/AllowanceUtilities";

const useCartAllowance = () => {
    const { cartId } = useAppSelector(state => getQueryStrings(state));
    const cartState = cartId
        ? useAppSelector(state => getCartState(state, cartId))
        : useAppSelector(state => getCurrentCartState(state));

    const cart = cartState.value;

    if (!cart) {
        return {
            allowanceApplied: null,
            hasAllowanceApplied: null,
            allowanceAppliedDisplay: null,
            allowanceAvailable: null,
            hasAllowanceAvailable: null,
            allowanceAvailableDisplay: null,
            allowanceRemaining: null,
            hasAllowanceRemaining: null,
            allowanceRemainingDisplay: null,
        };
    }

    return getAllowancesProperties(cart.properties);
};

export { useCartAllowance };
